import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import selfDirectives from '@/assets/js/directives.js'
// quill警告屏蔽
(function () {
  const proto = Node.prototype;
  if (proto.addEventListener) {
    const nativeAdd = proto.addEventListener;
    proto.addEventListener = function (type, fn, opts) {
      if (type === 'DOMNodeInserted') return; // 忽略
      return nativeAdd.call(this, type, fn, opts);
    };
  }
})();
import ElementPlus from 'element-plus'// element
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import common from '@/assets/js/common.js'// 公用方法
import moment from 'moment'// 时间插件
import breadcrumb from './components/breadcrumb'// 面包屑组件
import addressSelection from './components/common/addressSelection'// 地址选择组件
import tableModule from './components/common/tableModule'// 地址选择组件
import { QuillEditor } from '@vueup/vue-quill'// 富文本
import '@/assets/icon/iconfont.css' // 引入阿里图标 CSS
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@/assets/css/public.scss'
import '@/assets/css/quillEditor.scss'
import * as echarts from 'echarts/core' // echarts

const app = createApp(App)
app.config.globalProperties.$common = common
app.config.globalProperties.$moment = moment
app.config.globalProperties.$echarts = echarts
app.use(selfDirectives) // 自定义指令
app.component('breadcrumb-box', breadcrumb)
app.component('address-selection', addressSelection)
app.component('QuillEditor', QuillEditor)
app.component('tableModule', tableModule)

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    sessionStorage.clear()
    store.state.storageData = {}
    document.title = '综合服务平台'
  }
  const token = sessionStorage.getItem('token')
  if (!token && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})
// 防止修改sessionStorage
window.addEventListener('storage', (e) => {
  sessionStorage.setItem(e.key, e.oldValue)
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')
